module.exports = __webpack_public_path__ + "img/casa1.b70bff91.png";